<div class="users-tags-wrapper">
  <button
    *ngIf="items.length > 0"
    type="button"
    class="users-tags__close-btn users-tags__remove-all-btn"
    (click)="removeAllItems.emit()"
  >
    <tui-icon [style.border-width.rem]="0.25" icon="@tui.x"></tui-icon>
  </button>

  <tui-scrollbar class="users-tags">
    <div class="users-tags__list">
      <div *ngFor="let item of items" class="users-tags__item">
        <span class="tui-text_body-s-2">
          {{ item.fullName }}
        </span>

        <button type="button" class="users-tags__close-btn" (click)="removeItem.emit(item)">
          <tui-icon [style.border-width.rem]="0.25" icon="@tui.x"></tui-icon>
        </button>
      </div>
    </div>
  </tui-scrollbar>
</div>
